/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyAddress
 */
export interface FreelancerCompanyAddress {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddress
     */
    region?: string;
}

/**
 * Check if a given object implements the FreelancerCompanyAddress interface.
 */
export function instanceOfFreelancerCompanyAddress(value: object): value is FreelancerCompanyAddress {
    return true;
}

export function FreelancerCompanyAddressFromJSON(json: any): FreelancerCompanyAddress {
    return FreelancerCompanyAddressFromJSONTyped(json, false);
}

export function FreelancerCompanyAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function FreelancerCompanyAddressToJSON(value?: FreelancerCompanyAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'region': value['region'],
    };
}

